module.exports = __webpack_public_path__ + "static/media/noAnimation.da717388.png";